import React, {useEffect, useState} from 'react';
import {Card} from 'antd';
import {
  changeServicePage,
  changeClientPage,
  clearAppointmentBookingDetails,
  clearClassBookingDetails,
} from '../../../redux/actions';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import '../public-appointment.scss';
import useQuery from '../../../hooks/useQuery';
import Axios from 'axios';
import {BASE_URL_WEB} from '../../../utility/constants';
const PublicSessionsCardList = ({
  servicesList,
  setTrainerList,
  setSelectedService,
  selectedService,
}) => {
  const dispatch = useDispatch();
  const publicUser = useSelector(state => state.publicUser);
  const authDetails = useSelector(state => state.auth);
  const history = useHistory();
  const branchId = useSelector(state => state.auth.companyData?.branch?.id);
  const branchIdUrlQuery = useQuery().get('branchId');
  const trainerIdUrlQuery = useQuery().get('trainerId');
  const [companyData, setCompanyData] = useState([]);
  useEffect(() => {
    let cancelled = false;
    if (authDetails.companyData?.CTCM !== undefined) {
      setCompanyData(authDetails.companyData);
    } else if (publicUser?.companyId) {
      Axios({method: 'GET', url: `${BASE_URL_WEB}public-company-data/${publicUser.companyId}`})
        .then(response => {
          if (!cancelled) setCompanyData(response.data);
        })
        .catch(() => {
          if (!cancelled) setCompanyData({});
        });
    }
    return () => {
      cancelled = true;
    };
  }, [authDetails.companyData, publicUser?.companyId]);

  return (
    <div className="row">
      {companyData?.CTCM === false &&
      companyData?.booking_max_days !== null &&
      // authDetails?.companyData?.booking_max_days !== null &&
      // authDetails?.companyData?.booking_max_days !== undefined &&
      servicesList?.length > 0 ? (
        servicesList?.some(({trainer}) =>
          trainer?.some(
            x =>
              x.branchTrainersBranchId === (branchIdUrlQuery || branchId) &&
              (!trainerIdUrlQuery || x.branchTrainersTrainerId === trainerIdUrlQuery) &&
              x.availability !== false
          )
        ) ? (
          servicesList?.map(({service, trainer}) => {
            const serviceTrainers = trainer?.filter(
              x =>
                x.branchTrainersBranchId === (branchIdUrlQuery || branchId) &&
                (!trainerIdUrlQuery || x.branchTrainersTrainerId === trainerIdUrlQuery) &&
                x.availability !== false
            );

            return (
              <React.Fragment key={service?.uuid}>
                {serviceTrainers?.length > 0 && (
                  <Card
                    className={`card-session ${
                      service?.uuid === selectedService?.uuid && 'selected-card'
                    }`}
                    onClick={() => {
                      if (authDetails.authDetails) {
                        dispatch(clearAppointmentBookingDetails());
                        dispatch(changeServicePage(service));
                        dispatch(clearClassBookingDetails());
                        if (trainerIdUrlQuery) {
                          dispatch(changeClientPage(serviceTrainers[0]));
                        }
                        history.push('/booking');
                      } else {
                        setTrainerList(serviceTrainers);
                        setSelectedService(service);
                      }
                    }}
                    key={service?.uuid}
                    hoverable
                    style={{width: 300, marginRight: 25, marginBottom: 25}}
                  >
                    <Card.Meta
                      title={<span className="font-size-18 txt">{service?.serviceName}</span>}
                      description={
                        <p className="service-scroll font-size-15 txt">{service?.description}</p>
                      }
                    />
                  </Card>
                )}
              </React.Fragment>
            );
          })
        ) : (
          <h3>No services available</h3>
        )
      ) : (
        <h3>No services available</h3>
      )}
    </div>
  );
};

export default PublicSessionsCardList;
